import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LabeledList from '~/components/LabeledList';

interface NoModelsFoundProps {
    message?: string;
}

export default function NoModelsFound({ message }: NoModelsFoundProps) {
    return (
        <LabeledList label="Model">
            <Box display="flex" justifyContent="center" width="100%">
                <Typography variant="body2">
                    {message ?? (
                        <>
                            <FormattedMessage id="noModelsFound" />.
                        </>
                    )}
                </Typography>
            </Box>
        </LabeledList>
    );
}
